<template>
    <span>
      <vs-switch v-model="openTasks" color="dark" icon-pack="feather" vs-icon="icon-chevron-down"  />
      <!-- <vs-switch v-model="collapseTasks" icon-pack="feather" vs-icon="icon-chevron-up"  /> -->
    </span>

</template>

<script>
import draggable from 'vuedraggable'
import Task from './Task'

export default {
  components: {
    draggable,
    Task,
  },
  props: ['value'],
  data () {
    return {
      openTasks: this.value,
      collapseTasks: this.value === false,
    }
  },
  watch: {
    'openTasks': {
      immediate: false,
      handler (value) {
        if (value) {
          this.collapseTasks = false
        }

        this.inputChanged()
      }
    },
    'collapseTasks': {
      immediate: false,
      handler (value) {
        if (value) {
          this.openTasks = false
        }

        this.inputChanged()
      }
    }
  },
  methods: {
    inputChanged () {
      if (this.openTasks) {
        this.$emit('input', true)
        return true
      } else if (this.collapseTasks) {
        this.$emit('input', false)
      } else {
        this.$emit('input', null)
      }
    },
  }
}

</script>
